class User {
	id = null;
	username = '';
	password = '';
	buildings = [];
	active = true;
	user_role_id = 2;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = '';
			}
		}
	}
}

export default User;
